import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { formatImage } from '@ifeng-fe/public_method';

/**
 * 定义 Footer 组件
 */
class Banner extends React.PureComponent {
    static propTypes = {
        firstModuleData: PropTypes.array,
    };

    /**
     * 渲染组件
     */
    render() {
        const { firstModuleData } = this.props;

        return (
            <div className={styles.highAttention}>
                {firstModuleData.map((item, index) => {
                    if (index === 0) {
                        return (
                            <div key={index} className={styles.leftImgOne}>
                                <a href={item.url} target="_blank">
                                    {item?.thumbnails?.image?.[0]?.url && (
                                        <img src={formatImage(item.thumbnails.image[0].url || '', 650, 440)} />
                                    )}
                                    <div className={styles.highAttentionText}>{item?.title}</div>
                                </a>
                            </div>
                        );
                    } else {
                        return (
                            <div key={index} className={styles.rightImgOne}>
                                <a href={item.url} target="_blank">
                                    {item?.thumbnails?.image?.[0]?.url && (
                                        <img src={formatImage(item.thumbnails.image[0].url || '', 210, 140)} />
                                    )}
                                    <div className={styles.highAttentionText}>{item?.title}</div>
                                </a>
                            </div>
                        );
                    }
                })}
            </div>
        );
    }
}

export default errorBoundary(Banner);
